const contacts = [
  {social: 'email', href: 'mailto:sauravthakur188@gmail.com', text:'sauravthakur188@gmail.com'},
  {social: 'linkedin', href: 'https://www.linkedin.com/in/saurav-thakur-b366761b5/', text: "in/saurav-thakur-b366761b5"},
  {social: 'github', href: 'https://github.com/saurav188', text: "/saurav188"}
];

export default contacts;